import React from "react";
import { useTranslation } from "react-i18next";
import CommonIcons from "@base/assets/icons";
import CommonStyles from "..";
import themeColor from "@base/themes/colorTheme";

/** Reminder on an unpaid booking that a transfer or cash payment is still to be confirmed. */
export default function CardTransferInfo({ showDetail }: { showDetail?: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="p-3 border border-solid border-common-blue500 bg-common-blue100 rounded-lg">
      <div className="flex items-start gap-2">
        <div>
          <CommonIcons.InfoCircleOutlined style={{ color: themeColor.blue500, fontSize: 18 }} />
        </div>

        <div className="flex flex-col gap-1">
          <CommonStyles.TypographyUI use="paragraph" className="text-sm font-normal text-common-blue500 !mb-0 whitespace-pre-line">
            {t("appointmentDetail.transferNotice")}
          </CommonStyles.TypographyUI>
          <CommonStyles.TypographyUI use="paragraph" className="text-sm font-medium text-common-blue500 !mb-0 cursor-pointer" onClick={showDetail}>
            {t("appointmentDetail.seeDetail")} &gt;
          </CommonStyles.TypographyUI>
        </div>
      </div>
    </div>
  );
}
